export enum TIMESPAN {
  week = 'week',
  month = 'month',
  year = 'year',
  allTime = 'allTime',
  fiveYears = '5',
  tenYears = '10',
  fifteenYears = '15',
}
